import { PurchaseOrder } from '../../../clients/quipli-service/purchase-order/purchase-order';
import React from 'react';
import { usePurchaseOrderApiV1 } from '../../../clients/quipli-service/purchase-order/purchase-order-api-v1';
import { toast } from '../../../util/toasts';
import { ConfirmModal } from '../../../components/modal/confirm-modal';

export const CancelPurchaseOrder = ({
  purchaseOrder,
  onCancel,
  onComplete,
}: {
  purchaseOrder: PurchaseOrder;
  onCancel: () => void;
  onComplete: () => void;
}) => {
  const { cancelPurchaseOrder } = usePurchaseOrderApiV1();

  const doCancel = async () => {
    try {
      await cancelPurchaseOrder(purchaseOrder.id);
      onComplete();
    } catch (e: any) {
      toast(e.message || 'Failed to cancel purchase order', 'error');
    }
  };

  return (
    <ConfirmModal
      isOpen={true}
      prompt="Are you sure you want to cancel this purchase order?"
      close={onCancel}
      onConfirm={doCancel}
    />
  );
};
